import {
  ExOrderBundleLineMapper,
  ExOrderMapper,
  ExOrderModel,
  ExOrderProductLineModel,
  ExProductDeliveryOption,
} from "../models";
import {
  BundleLines,
  ProductBundler,
  ProductLines,
  ProductListHeader,
} from "./product-list";
import { TotalPrice } from "../../common/components/panels/TotalPrice";
import { getTotals } from "../utils/ExOrderHelper";
import { AddProductLine } from "./product-list/AddProductLine";

export function ProductListPanel({
  order,
  onSetOrder,
  showBundles,
  readonly,
}: {
  order: ExOrderModel;
  onSetOrder: (updatedOrder: ExOrderModel) => void;
  showBundles?: boolean;
  readonly?: boolean;
}) {
  const { totalPrice, totalProfit } = getTotals({
    ...ExOrderMapper.empty(),
    bundles: order.bundles,
    products: order.products,
  });

  const excludedDeliveryOptions =
    order.order.typeSap === "zxmt_inn"
      ? ["ZTMU"]
      : order.order.typeSap === "zxmt"
        ? ["ZTMI"]
        : order.order.typeSap === "zx20"
          ? ["ZTMU", "ZTMI"]
          : [];

  return (
    <div className="flex flex-col w-full text-sm">
      {showBundles ? (
        <ProductBundler
          onAddBundle={(bundle) =>
            onSetOrder({
              ...order,
              bundles: [
                ...order.bundles,
                ExOrderBundleLineMapper.fromProductBundle(bundle),
              ],
            })
          }
        />
      ) : null}
      <ProductListHeader />
      {showBundles ? (
        <BundleLines
          bundles={order.bundles}
          onSetBundles={(bundles) => onSetOrder({ ...order, bundles: bundles })}
        />
      ) : null}
      <ProductLines
        readonly={readonly}
        productLines={order.products}
        onSetProductLines={(products) =>
          onSetOrder({ ...order, products: products })
        }
      />
      {!readonly ? (
        <AddProductLine
          onAdd={(newLine: ExOrderProductLineModel) =>
            onSetOrder({ ...order, products: [...order.products, newLine] })
          }
          excludedDeliveryOptions={excludedDeliveryOptions}
        />
      ) : null}
      <div className="flex -mr-2 mt-2">
        <TotalPrice price={totalPrice} profit={totalProfit} />
      </div>
    </div>
  );
}
